import { TPlanSummary } from './cms-types'

export enum PlanSlug {
  PHONE = 'virtual-office-whatsapp-for-business-number',
  SCAN_LITE = 'Virtual-Office-London',
  SCAN_PRO = 'Virtual-Office-London-Mail-Forwarding',
}

export enum PlanLinks {
  PHONE = 'virtual-office-phone',
  SCAN_LITE = 'virtual-office-london-old-street',
  SCAN_PRO = 'virtual-office-forward',
}
export const planOrder = [PlanSlug.SCAN_LITE, PlanSlug.SCAN_PRO, PlanSlug.PHONE]

export enum AddonSlug {
  'Virtual-Office-London-Mail-Forwarding' = PlanSlug.SCAN_PRO,
  DIRECTORS_SERVICE_ADDRESS = 'director-service-address-addon',
  VIRTUAL_OFFICE_PHONE = 'addon-virtual-office-phone',
  TIDE_BUSINESS_BANKING = 'TIDE',
  CRUNCH = 'CRUNCH',
  INTRODUCTION_TO_AN_ACCOUNTANT = 'addon-introduction-to-an-accountant',
}
export const additionalPlans = [PlanSlug.PHONE]
export const hideAddonsMapping = {
  [PlanSlug.PHONE]: true,
  [PlanSlug.SCAN_LITE]: false,
  [PlanSlug.SCAN_PRO]: false,
}

export const planToParent = {
  [PlanSlug.SCAN_PRO]: PlanSlug.SCAN_LITE,
}

export function getParentPlan(planSlug: PlanSlug, plans: TPlanSummary[]) {
  if (planToParent[planSlug]) {
    return plans.find((v) => v.slug === planToParent[planSlug])
  }
}

export const addonToProductMapping = {
  [PlanSlug.PHONE]: null,
  [PlanSlug.SCAN_LITE]: null,
  [PlanSlug.SCAN_PRO]: null,
}
